export const typeOptions = [
  { value: 'text/plain', label: 'text'},
  { value: 'text/css', label: 'css code'},
  { value: 'text/html', label: 'html code' },
  { value: 'text/javascript', label: 'javascript code' },
  { value: 'text/bash', label: 'bash code' },
  { value: 'text/json', label: 'json code' },
  { value: 'text/yaml', label: 'yaml code' },
];
